// Generated by scripts/build-ui-icons.mjs.
export { Robot as default } from "../ui/glyphs-6";
